import React, { useState, useEffect } from "react";
import ImageWithText from "./ImageWithText";

export const Summary = () => {
  const [displayText, setDisplayText] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState("Overview");
  const [fadeClass, setFadeClass] = useState("fade-in");

  useEffect(() => {
    if (selectedTitle === "Overview" && displayText === null) return;
    setFadeClass(""); 
    const timer = setTimeout(() => {
      setFadeClass("fade-in");
    }, 10);
    return () => clearTimeout(timer);
  }, [selectedTitle]);

  const handleImageClick = (clickedArea) => {
    let newDisplayText = null;
    let newTitle = "Overview";
    if (clickedArea && clickedArea === selectedTitle) {
        return;
    }

    if (clickedArea) {
      newTitle = clickedArea;
      switch (clickedArea) {
        case "Database":
          newDisplayText = (
            <p>
              SolarWinds empowers businesses by streamlining the monitoring,
              analysis, diagnosis, and optimization of critical database
              performance for business applications. Unifying on-premises and
              cloud database visibility, it provides streamlined monitoring,
              mapping, data lineage, integration, and tuning across vendors.
            </p>
          );
          break;
        case "Network":
          newDisplayText = (
            <p>
              Network management tools, from configuration and traffic
              intelligence to performance monitoring and topology mapping, to
              readily see, understand, and resolve issues. An integrated,
              multi-vendor approach that’s easy to use, extend, and scale to keep
              distributed networks optimized.
            </p>
          );
          break;
        case "Infrastructure":
          newDisplayText = (
            <p>
              SolarWinds infrastructure solutions help organizations assure the
              health and configuration of physical and virtual servers,
              containers, private cloud, storage, and network infrastructure
              across hybrid IT environments.
            </p>
          );
          break;
        case "Application":
          newDisplayText = (
            <p>
              SolarWinds excels in application monitoring, offering real-time
              performance insights, customizable alerts, and automated dependency
              mapping. Emphasizing user experience tracking, log analysis, and
              capacity planning, it ensures optimal application performance.
            </p>
          );
          break;
        case "Cloud":
          newDisplayText = (
            <p>
              SolarWinds Server & Application Monitor (SAM) is built to provide
              end-to-end visibility into business-critical applications, regardless
              of whether they’re running on private, public, or hybrid cloud
              environments.
            </p>
          );
          break;
        case "Solarwinds":
          newDisplayText = (
            <p>
              SolarWinds stands out as the sole unified platform that seamlessly
              combines monitoring, observability, and service management. It
              empowers users with comprehensive insight into their IT
              infrastructure.
            </p>
          );
          break;
        case "Automate":
          newDisplayText = (
            <p>
              SolarWinds Network Configuration Manager (NCM) leverages network
              automation to make bulk configuration changes to wired and
              wireless devices. This helps you save time and reduces errors.
            </p>
          );
          break;
        case "Observe":
          newDisplayText = (
            <p>
              The SolarWinds Platform is the industry’s only unified monitoring,
              observability, and service management platform. It’s the foundation
              for a new generation of SolarWinds observability solutions.
            </p>
          );
          break;
        case "Remediate":
          newDisplayText = (
            <p>
              SolarWinds remediation efforts involve thorough investigation,
              patching vulnerable systems, and implementing enhanced security
              measures.
            </p>
          );
          break;
        case "Visualize":
          newDisplayText = (
            <p>
              SolarWinds network visualization tools provide a unified view of
              network connections, applications, dependency relationships,
              topology, and ADM information to quickly isolate and identify issues.
            </p>
          );
          break;
        default:
          newDisplayText = null;
          newTitle = "Overview";
      }
    }

    setDisplayText(newDisplayText);
    setSelectedTitle(newTitle);
  };

  const defaultText = (
    <p>
      SolarWinds stands out as the sole unified platform that seamlessly
      combines monitoring, observability, and service management. It empowers
      users with comprehensive insight into their hybrid IT infrastructure,
      enabling proactive identification of bottlenecks across the entire
      system. <br />
      <br />
      <strong>Click on the different areas of the image to learn more.</strong>
    </p>
  );

  return (
    <div className="summary-container">
      <div className="image-section">
        <ImageWithText onClick={handleImageClick} />
      </div>
      <div className="text-section">
        <div className={`info-box ${fadeClass}`}>
          <h2 className="info-title">{selectedTitle}</h2>
          <div className="info-content">{displayText || defaultText}</div>
        </div>
      </div>
    </div>
  );
};